import { createContext, useContext } from "react";

import type { EmployeeGroup } from "~/providers/employee-group-provider";

interface EmployeeGroupContext {
  employeeGroups: EmployeeGroup[];
}

export const EmployeeGroupContext = createContext<
  EmployeeGroupContext | undefined
>(undefined);

export const useEmployeeGroup = () => {
  const context = useContext(EmployeeGroupContext);

  if (context === undefined) {
    throw new Error(
      "useEmployeeGroup must be used within a EmployeeGroupProvider, but no provider was found",
    );
  }

  return context;
};
